export enum userRolEnum {
    admin = "ppafeAdmin",
    carga = "ppafeCarga",
    revisa = "ppafeRevisa",
    valida = "ppafeCaptura",
}

export enum SemaforizacionEnum {
    puntual = "Puntual",
    proceso = "Proceso",
    retraso = "Retraso",
}

export enum flujoEnum {
    revision = "REVISION",
    validacion = "VALIDACION",
    publicado = "PUBLICADO",
    devuelto = "DEVUELTO",
    oculto = "OCULTO",
}

export const FlujoStatus = (statusActual: string, accion: "avanzar" | "devolver") => {
    switch (statusActual) {
        case flujoEnum.revision:
            return accion === "avanzar" ? flujoEnum.validacion : flujoEnum.devuelto;
        case flujoEnum.validacion:
            return accion === "avanzar" ? flujoEnum.publicado : flujoEnum.revision;
        case flujoEnum.devuelto:
            return flujoEnum.revision;
        case flujoEnum.publicado: // 👈 Nuevo caso agregado
            return flujoEnum.validacion; // 👈 Ahora regresa a validacion
        case "ELIMINAR":
            return flujoEnum.oculto;
        case flujoEnum.oculto:
            return accion === "avanzar" ? flujoEnum.revision : flujoEnum.oculto;
        default:
            return "Estatus desconocido";
    }
};


export enum ZonaEnum {
    redes = "REDES",
    top = "TOP",
    pie = "PIE",
    gobierno = "GOBIERNO",
    notiicación = "NOTIFICACION",
}
